@if (isLoading$()) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
    <span class="loading-text" i18n>Lade Anwendung</span>
  </div>
} @else {
  <div class="container">
    @if (
      notificationBarVisible &&
      (notificationBarService.getNotificationBarVisibility() | async)
    ) {
      <app-notification-bar></app-notification-bar>
    }
    @if (menubarVisible) {
      <app-menu-bar
        [navigationAvailable]="sideNav.showSideNav"
        [navigationExpanded]="sideNav.compactNavigationOpen()"
        (navigationToggle)="sideNav.toggleCompactNavigation($event)"
      ></app-menu-bar>
    }
    @if (connectivity.hasConnectionError()) {
      <app-feedback-message
        class="connectivity-banner"
        appearance="banner"
        tone="info"
        icon="wifi_off"
        announcement="polite"
        title="Die Verbindung ist unterbrochen"
        i18n-title="@@connectivityBannerTitle"
        message="Der Server ist gerade nicht erreichbar. Wir prüfen die Verbindung automatisch erneut."
        i18n-message="@@connectivityBannerMessage"
        actionLabel="Verbindung prüfen"
        i18n-actionLabel="@@connectivityBannerRetry"
        [busy]="connectivity.checking()"
        (actionTriggered)="connectivity.retryConnection()"
      ></app-feedback-message>
    }
    <app-side-nav
      #sideNav
      class="main-content"
      (activatedComponentChanged)="activatedComponentChanged($event)"
    ></app-side-nav>
  </div>
}
